/* aydevelops theme — base scripts (original) */
(function () {
  'use strict';

  /* ---- Mobile navigation ---- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    function open() { nav.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { nav.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    toggle.addEventListener('click', open);
    nav.addEventListener('click', function (e) {
      if (e.target === nav || e.target.closest('[data-menu-close]')) close();
    });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Quantity steppers ---- */
  function initQuantity() {
    document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-qty-step') === 'down' ? -1 : 1;
          var min = parseInt(input.min || '1', 10);
          var val = (parseInt(input.value, 10) || min) + step;
          if (val < min) val = min;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Slideshow ---- */
  function initSlideshow() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var track = root.querySelector('[data-slideshow-track]');
      var slides = root.querySelectorAll('.slideshow__slide');
      var dots = root.querySelectorAll('[data-slideshow-dot]');
      if (slides.length < 2) return;

      var index = 0;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = (parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
      var timer;

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (d, di) { d.setAttribute('aria-current', di === index ? 'true' : 'false'); });
      }
      function next() { go(index + 1); }
      function start() { if (autoplay) timer = setInterval(next, speed); }
      function stop() { clearInterval(timer); }

      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { stop(); go(di); start(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      go(0);
      start();
    });
  }

  /* ---- Announcement bar (rotate one message at a time) ---- */
  function initAnnouncementBar() {
    document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
      var track = bar.querySelector('[data-announcement-track]');
      if (!track) return;
      var slides = track.querySelectorAll('[data-announcement-slide]');
      if (slides.length < 2) return;

      var index = 0;
      var autoplay = bar.getAttribute('data-autoplay') === 'true';
      var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
      var timer;

      function go(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function start() { if (autoplay) timer = setInterval(next, speed); }
      function stop() { clearInterval(timer); }

      var prevBtn = bar.querySelector('[data-announcement-prev]');
      var nextBtn = bar.querySelector('[data-announcement-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { stop(); prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stop(); next(); start(); });
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);

      go(0);
      start();
    });
  }

  /* ---- Product variant selection (no checkout dependency) ---- */
  function initVariantPicker() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var variants;
      try { variants = JSON.parse(form.querySelector('[data-variants-json]').textContent); }
      catch (e) { return; }

      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-product-price]');
      var addBtn = form.querySelector('[data-add-to-cart]');

      function currentOptions() {
        var selected = [];
        form.querySelectorAll('[data-option-index]').forEach(function (el) {
          if (el.type === 'radio') {
            var checked = form.querySelector('[data-option-index="' + el.getAttribute('data-option-index') + '"]:checked');
            if (checked) selected[parseInt(el.getAttribute('data-option-index'), 10)] = checked.value;
          } else {
            selected[parseInt(el.getAttribute('data-option-index'), 10)] = el.value;
          }
        });
        return selected;
      }

      function update() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl && match.price != null) {
          priceEl.textContent = formatMoney(match.price);
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.getAttribute('data-add-label') : addBtn.getAttribute('data-soldout-label');
        }
      }

      form.querySelectorAll('[data-option-index]').forEach(function (el) {
        el.addEventListener('change', update);
      });
      update();
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return (window.Shopify && Shopify.currency ? '' : '') + '$' + amount;
  }

  /* ---- Cart count ---- */
  function setCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    // Only the icon bubble hides when empty; the text label "(0)" always shows.
    document.querySelectorAll('[data-cart-bubble]').forEach(function (el) {
      el.hidden = cart.item_count === 0;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshCartCount() {
    if (!document.querySelector('[data-cart-count]')) return;
    fetchCart().then(setCartCount).catch(function () {});
  }

  /* ---- Cart drawer ---- */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var toggles = document.querySelectorAll('[data-cart-toggle]');
    if (!drawer) return; // drawer disabled — links/forms behave normally

    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footerEl = drawer.querySelector('[data-cart-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');

    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function lineHTML(item) {
      var img = item.image || (item.featured_image && item.featured_image.url) || '';
      var variant = item.variant_title ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      var media = img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" width="70" height="90" loading="lazy">' : '';
      return '' +
        '<div class="cart-line" data-line-key="' + escapeHtml(item.key) + '" data-line-qty="' + item.quantity + '">' +
          '<a href="' + escapeHtml(item.url) + '" class="cart-line__media">' + media + '</a>' +
          '<div class="cart-line__info">' +
            '<a href="' + escapeHtml(item.url) + '" class="cart-line__title">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-line__qty">' +
              '<button type="button" data-line-decrease aria-label="-">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line-increase aria-label="+">&plus;</button>' +
              '<button type="button" class="cart-line__remove" data-line-remove>' + REMOVE_LABEL + '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    function render(cart) {
      setCartCount(cart);
      if (!itemsEl) return;
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      itemsEl.innerHTML = cart.items.map(lineHTML).join('');
    }

    function change(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render);
    }

    var REMOVE_LABEL = (itemsEl && itemsEl.getAttribute('data-remove-label')) || 'Remove';

    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var line = e.target.closest('[data-line-key]');
        if (!line) return;
        var key = line.getAttribute('data-line-key');
        var qty = parseInt(line.getAttribute('data-line-qty'), 10) || 1;
        if (e.target.closest('[data-line-remove]')) change(key, 0);
        else if (e.target.closest('[data-line-increase]')) change(key, qty + 1);
        else if (e.target.closest('[data-line-decrease]')) change(key, Math.max(0, qty - 1));
      });
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        open();
        fetchCart().then(render);
      });
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) close();
    });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });

    /* Add-to-cart -> open drawer instead of redirecting */
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () { return fetchCart(); })
          .then(function (cart) { render(cart); open(); })
          .catch(function () { form.submit(); })
          .then(function () { if (btn) btn.disabled = false; });
      });
    });

    /* Quick add (complementary "Pairs well with" cards) -> add + open drawer */
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetchCart(); })
          .then(function (cart) { render(cart); open(); })
          .catch(function () {})
          .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---- Collection tabs ---- */
  function initCollectionTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var btns = root.querySelectorAll('[data-tab-btn]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      if (!btns.length) return;
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-tab-btn');
          btns.forEach(function (b) {
            var on = b.getAttribute('data-tab-btn') === i;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-tab-panel') === i;
            p.classList.toggle('is-active', on);
            p.hidden = !on;
          });
          window.dispatchEvent(new Event('resize'));
        });
      });
    });
  }

  /* ---- Carousels ---- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.product-card');
        var style = getComputedStyle(track);
        var gap = parseInt(style.columnGap || style.gap, 10) || 20;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function refresh() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      refresh();
    });
  }

  /* ---- Header (transparent overlay + solid-on-scroll) ---- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    function setHeight() {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
    setHeight();
    window.addEventListener('resize', setHeight);

    // Only enable transparent behavior when the first section opts in.
    var main = document.querySelector('main');
    var first = main && main.firstElementChild;
    var overlay = first && (first.matches('[data-allow-transparent-header]') || first.querySelector('[data-allow-transparent-header]'));
    if (!overlay) return;

    function onScroll() {
      header.classList.toggle('is-solid', window.scrollY > 50);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Browsers don't reliably autostart muted autoplay videos that are below the
  // fold (especially with preload="metadata"). Force play when they enter view
  // so background videos always autoplay, and pause off-screen to save battery.
  function initVideoAutoplay() {
    var videos = document.querySelectorAll('.video-section__media video, video[autoplay]');
    if (!videos.length) return;

    function tryPlay(v) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* ignore autoplay rejection */ });
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(tryPlay);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) tryPlay(v);
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.1 });

    videos.forEach(function (v) { io.observe(v); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMobileNav();
    initAnnouncementBar();
    initQuantity();
    initSlideshow();
    initVariantPicker();
    initCartDrawer();
    initCollectionTabs();
    initCarousels();
    initVideoAutoplay();
    refreshCartCount();
  });
})();
